import { render, staticRenderFns } from "./TTS.vue?vue&type=template&id=38e81012&scoped=true"
import script from "./TTS.vue?vue&type=script&lang=js"
export * from "./TTS.vue?vue&type=script&lang=js"
import style0 from "./TTS.vue?vue&type=style&index=0&id=38e81012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e81012",
  null
  
)

export default component.exports